import {
  Accessibility,
  ArrowLeft,
  ChevronLeft,
  ChevronRight,
  Compass,
  Expand,
  Eye,
  Glasses,
  Globe,
  CircleHelp,
  Languages,
  LayoutGrid,
  ChevronsDown,
  ChevronsUp,
  Link as LinkIcon,
  List,
  Map as MapIcon,
  MapPin,
  Maximize,
  Menu,
  MessageCircle,
  Minimize,
  Minus,
  Navigation,
  Pause,
  Play,
  Plus,
  RotateCw,
  Send,
  Share2,
  Smartphone,
  Volume2,
  VolumeX,
  X,
} from "lucide";
import { registerIcons, type IconNode } from "@andarama/viewer";

/** Registra los iconos de interfaz de la skin en el registro del visor. */
export function registerUiIcons(): void {
  registerIcons({
    accessibility: Accessibility as IconNode,
    "arrow-left": ArrowLeft as IconNode,
    "layout-grid": LayoutGrid as IconNode,
    "chevrons-down": ChevronsDown as IconNode,
    "chevrons-up": ChevronsUp as IconNode,
    "chevron-left": ChevronLeft as IconNode,
    "chevron-right": ChevronRight as IconNode,
    compass: Compass as IconNode,
    expand: Expand as IconNode,
    eye: Eye as IconNode,
    glasses: Glasses as IconNode,
    globe: Globe as IconNode,
    "circle-help": CircleHelp as IconNode,
    languages: Languages as IconNode,
    link: LinkIcon as IconNode,
    list: List as IconNode,
    map: MapIcon as IconNode,
    "map-pin": MapPin as IconNode,
    maximize: Maximize as IconNode,
    menu: Menu as IconNode,
    "message-circle": MessageCircle as IconNode,
    minimize: Minimize as IconNode,
    minus: Minus as IconNode,
    navigation: Navigation as IconNode,
    pause: Pause as IconNode,
    play: Play as IconNode,
    plus: Plus as IconNode,
    "rotate-cw": RotateCw as IconNode,
    send: Send as IconNode,
    "share-2": Share2 as IconNode,
    smartphone: Smartphone as IconNode,
    "volume-2": Volume2 as IconNode,
    "volume-x": VolumeX as IconNode,
    x: X as IconNode,
  });
}
